import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Search } from "lucide-react";

const categories = [
  { id: "all", label: "Semua" },
  { id: "cabinet", label: "Cabinet Vila" },
  { id: "aviary", label: "Aviary" },
  { id: "xl", label: "XL Outdoor" },
  { id: "premium", label: "Luxury" },
];

const Catalog = () => {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("all");
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get("/products", { params: { category } })
      .then((r) => setProducts(r.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [category]);

  const filtered = products.filter((p) =>
    p.name.toLowerCase().includes(query.toLowerCase()) ||
    p.short_description.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-14 lg:py-20" data-testid="catalog-page">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12">
        <div className="max-w-2xl">
          <div className="label-eyebrow text-[#E07A5F]">Koleksi Penuh</div>
          <h1 className="font-heading font-bold text-5xl sm:text-6xl tracking-tight text-[#1C1C1C] mt-3 text-balance">
            Katalog sangkar kucing.
          </h1>
          <p className="text-base text-[#4A4A4A] mt-5 leading-relaxed">
            Pilih sangkar yang sesuai dengan saiz, gaya, dan keperluan kucing anda.
            Semua produk datang dengan jaminan 1 tahun.
          </p>
        </div>

        <div className="relative w-full lg:w-80">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#4A4A4A]" />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Cari sangkar..."
            data-testid="catalog-search-input"
            className="w-full pl-11 pr-4 py-3 rounded-xl bg-white border border-[rgba(28,28,28,0.1)] focus:outline-none focus:border-[#E07A5F] text-sm"
          />
        </div>
      </div>

      <div className="flex items-center gap-2 overflow-x-auto scrollbar-none -mx-2 px-2 pb-2 mb-10">
        {categories.map((c) => (
          <button
            key={c.id}
            onClick={() => setCategory(c.id)}
            data-testid={`category-filter-${c.id}`}
            className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-semibold transition-all ${
              category === c.id
                ? "bg-[#1C1C1C] text-[#FAF9F6]"
                : "bg-white text-[#1C1C1C] border border-[rgba(28,28,28,0.1)] hover:border-[#1C1C1C]"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="bg-[#F4F1EA] aspect-[4/5] rounded-2xl animate-pulse" />
          ))}
        </div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-20" data-testid="catalog-empty">
          <p className="text-[#4A4A4A]">Tiada produk dijumpai untuk carian anda.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8" data-testid="catalog-grid">
          {filtered.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Catalog;
